<template>
  <div class="guide-dialog">
    <van-popup v-model="visible" :close-on-click-overlay="false">
      <!-- 高亮框 -->
      <div
        v-if="currentStep"
        class="guide-highlight"
        :style="highlightStyle"
        @click.stop
      ></div>

      <!-- 提示弹窗 -->
      <div
        v-if="currentStep"
        class="guide-popover"
        :style="popoverBaseStyle"
        @click.stop
      >
        <img :src="currentStep && currentStep.icon" style="width: 100%;" alt="" :style="{
        width: currentStep.iconWidth + 'px',
      }">
      </div>
      <div class="guide-buttons" v-if="currentStep">
        <div @click="next">{{ currentStep.step !== '6' ? '下一步' : '完成' }}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Guide',
  data() {
    return {
      visible: false,
      steps: [],
      stepIndex: 0,
    }
  },
  computed: {
    currentStep() {
      return this.steps[this.stepIndex]
    },
    highlightStyle() {
      if (!this.currentStep || !this.currentStep.rect) return {}
      const {top, left, width, height} = this.currentStep.rect
      // 扩大高亮区域的宽度和高度，并调整 left 和 top 以保持居中
      const expandedWidth = width + 5
      const expandedHeight = height + 5
      return {
        top: `${top - (expandedHeight - height) / 2}px`,
        left: `${left - (expandedWidth - width) / 2}px`,
        width: `${expandedWidth}px`,
        height: `${expandedHeight}px`
      }
    },
    popoverBaseStyle() { // 新增：提取基础样式
      if (!this.currentStep || !this.currentStep.rect) return {}
      const {top, left, width, height} = this.currentStep.rect
      const step = this.currentStep.step || '1'
      let style = {}

      // 获取扩大后的高亮区域尺寸
      const expandedWidth = width + 5
      const expandedHeight = height + 5

      switch (step) {
        case '1':
          style.top = `${top + expandedHeight}px`
          style.display = `flex`
          style.justifyContent = `center`
          style.alignItems = `center`
          break
        case '2':
          style.top = `${top + height - 10}px`
          style.left = `${left + width - 40}px`
          break
        case '3':
          style.top = `${top + expandedHeight / 2}px`
          style.left = `${left + expandedWidth}px`
          break
        case '4':
          style.top = `${top + expandedHeight / 2}px`
          style.left = `${left - this.currentStep.iconWidth / 2 - 20}px`
          break
        case '5':
          style.top = `${top + expandedHeight / 2}px`
          style.left = `${left + expandedWidth}px`
          break
        case '6':
          style.top = `${top + expandedHeight}px`
          style.display = `flex`
          style.justifyContent = `center`
          style.alignItems = `center`
          break
      }

      return style
    },
  },
  methods: {
    start(steps = []) {
      this.steps = steps
      this.stepIndex = 0
      this.visible = true

      // 初始化第一步高亮
      this.updateHighlight()
    },
    updateHighlight() {
      const step = this.currentStep
      const el = document.querySelector(step.selector)
      if (el) {
        const rect = el.getBoundingClientRect()
        this.$set(this.currentStep, 'rect', rect)
      }
    },
    next() {
      if (this.currentStep.step === '1') {
        this.$router.push('/database')
      } else if (this.currentStep.step !== '6') {
        this.stepIndex++
        this.updateHighlight()
        this.$emit('guide-step-change', this.currentStep)
      } else {
        this.$emit('guide-finish')
        this.visible = false
      }
    },
  },
}
</script>

<style scoped lang="less">
.guide-highlight {
  position: absolute;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
  z-index: 10000;
  border-radius: 10px;
}

.guide-popover {
  border-radius: 4px;
  pointer-events: none; /* 修改：阻止点击穿透 */
  z-index: 10001;
  position: relative; /* 新增：为伪元素提供定位参考 */
}

.guide-buttons {
  position: absolute;
  bottom: 20vh;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10002;

  & > div {
    width: 136px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #EB1700;
    border-radius: 22px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
  }
}

/deep/ .van-popup {
  background-color: transparent;
  overflow-y: visible;
  z-index: 10008 !important;
  height: 100%;
  width: 100%;
}

/deep/ .van-overlay {
  z-index: 10007 !important;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Guide.vue